export default __webpack_public_path__ + "static/media/igloo_1.d583ac20.jpg";